import Tr from 'translations/Translations';

const createItem = (trKey, value) => ({label: Tr(trKey), value})

export default [
    // createItem('p1s1_jedz_1', 'yes'),
    createItem('p1s1_jedz_2', 'yes'),
    createItem('p1s1_jedz_3', 'yesPostpone'),
    createItem('p1s1_jedz_4', 'no'),
]

export const jedzTranslations = (value) => {
    switch (value) {
        case "yes":
            return Tr("p1s1_jedz_2");
        case "yesPostpone":
            return Tr("p1s1_jedz_3");
        case "no":
            return Tr("p1s1_jedz_4");
        default:
            return ""
    }

}